import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { softwareList } from '@/mocks/software';
import SoftwareCard from '@/components/feature/SoftwareCard';

export default function LatestSoftware() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setLoading(false), 500);
    return () => window.clearTimeout(timer);
  }, []);

  const latest = [...softwareList]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 6);

  return (
    <div>
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">最新更新软件</h2>
          <p className="mt-1.5 text-sm text-foreground-500">实时跟进热门看片软件的版本迭代与功能更新</p>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看更多
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
          {[0, 1, 2, 3, 4, 5].map((n) => (
            <div key={n} className="animate-pulse overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="h-44 w-full bg-background-200"></div>
              <div className="space-y-3 p-4">
                <div className="h-4 w-2/3 rounded bg-background-200"></div>
                <div className="h-3 w-full rounded bg-background-200"></div>
                <div className="h-3 w-4/5 rounded bg-background-200"></div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
          {latest.map((item) => (
            <SoftwareCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}